import { ToastContainer } from 'react-toastify';
import './App.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
import RoutingModule from './routing/RoutingModule';
import { FilterProvider } from './context/FilterContext';
import { AttendanceProvider } from './context/AttendanceContext';

function App() {
  return (
    <>
      <FilterProvider>
        <AttendanceProvider>
          <GoogleOAuthProvider clientId={`${process.env.REACT_APP_GOOGLE_API_KEY}`}>
            <RoutingModule />
          </GoogleOAuthProvider>
        </AttendanceProvider>
      </FilterProvider>
      <ToastContainer />
    </>
  );
}

export default App;